import { Cookies } from '../adapter/cookies'
import { CmpImpl } from './cmp.impl'
import { initGlobal } from './bootstrap/init-global'
import { initNexus } from './bootstrap/init-nexus'
import { ConsentProviderAdapter } from '../adapter/consent-provider.adapter'
import { ReceiptArchiver } from './receipt-archiver'
import { cookie } from '@otto-ec/global-resources/cookie'
import { AppsAdapter } from '../adapter/apps.adapter'
import { Cmp } from './cmp.type'
import { ConsentConfigLoader } from './consent-config/consent-config-loader'
import { ConsentConfigService } from './consent-config/consent-config.service'
import { OneTrustApiWrapper } from '../adapter/one-trust-api/onetrust-api.wrapper'
import { loggingService } from '../utils/logging/logger.instance'
import { Logger } from '../utils/logging/logger'
import { TcfApi } from './iab-tcf/tcf-api/tcf-api.type'
import { CmpIabTcfApiService } from './iab-tcf/cmp-iab-tcf-api.service'

const ONETRUST_API_LOAD_TIMEOUT = 20000
const ONETRUST_API_CHECK_INTERVAL = 100

init().catch((e) =>
  loggingService.error(new Error('Error initializing cmp', { cause: e }))
)

async function init() {
  const receiptArchiver = new ReceiptArchiver(loggingService)

  const cookies = new Cookies(cookie)
  const appsAdapter = new AppsAdapter(cookies)
  const oneTrustApiWrapper = new OneTrustApiWrapper(
    ONETRUST_API_LOAD_TIMEOUT,
    ONETRUST_API_CHECK_INTERVAL
  )
  const consentProviderAdapter = new ConsentProviderAdapter(
    appsAdapter,
    oneTrustApiWrapper,
    loggingService
  )

  const consentConfigService = new ConsentConfigService(
    new ConsentConfigLoader()
  )
  const cmp: Cmp = new CmpImpl(
    consentProviderAdapter,
    await initTcfApi(loggingService),
    receiptArchiver,
    cookies,
    loggingService,
    consentConfigService,
    appsAdapter
  )
  initNexus(cmp)
  initGlobal(cmp)
}
async function initTcfApi(loggingService: Logger): Promise<TcfApi> {
  return new CmpIabTcfApiService(loggingService)
}
